export var ACCOUNT_ACTION_IDS = {
  DEPOSIT_START: 'action.deposit.start',
  RECOVER_START: 'action.account.recovery.start',
  REOPEN_START: 'action.account.reopen.start',
  RESET_PASSWORD_START: 'action.account.password.reset.start',
  FAQ_PAGE_OPEN: 'action.account.faq.page.open',
  LIVE_CHAT_OPEN: 'action.live.chat.open',
  LOGIN_START: 'action.account.login.start',
  REGISTRATION_START: 'action.account.registration.start',
  MESSAGE_LOG: 'action.message.log',
  WELCOME_MESSAGES_OPEN: 'action.wm.open',
  WELCOME_MESSAGES_CAMPAIGN_DISPLAYED: 'action.wm.campaign.displayed',
  OPEN_BETSLIP: 'action.betslip.start',
  PLACE_BET: 'action.bet.place.start',
  LAUNCH_GAME: 'action.game.launch',
  NAVIGATE_TO: 'action.navigation.start'
};
//# sourceMappingURL=AccountActionIds.js.map